import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';

import { IconsModule } from '../icons/icons.module';
import { ChipButtonComponent } from './chip-button.component';
import { ChipComponent } from './chip.component';

@NgModule({
  declarations: [ChipButtonComponent, ChipComponent],
  imports: [CommonModule, UiTranslateModule, IconsModule],
  exports: [ChipButtonComponent, ChipComponent],
  providers: [],
})
export class ChipModule {}
